import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { heroKitImage } from "../data/landingContent";
type HeroKitProps = {
  className?: string;
};
export function HeroKit({
  className = ""
}: HeroKitProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div className={`relative ${className}`} initial={reduceMotion ? false : {
    opacity: 0,
    y: 16,
    scale: 0.96
  }} animate={reduceMotion ? undefined : {
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-98" data-mp="kd62dwx49fhr">
      <motion.div aria-hidden="true" className="absolute bottom-[2%] left-1/2 h-2 w-[58%] -translate-x-1/2 rounded-full bg-[#091a37]/10 blur-sm" animate={reduceMotion ? undefined : {
      opacity: [0.1, 0.06, 0.1],
      scaleX: [1, 0.88, 1]
    }} transition={{
      duration: 4.5,
      delay: 0.8,
      ease: "easeInOut",
      repeat: Infinity
    }} data-id="element-99" data-mp="bekoif2laonb" />
      <motion.div className="relative z-10" animate={reduceMotion ? undefined : {
      y: [0, -6, 0]
    }} transition={{
      duration: 4.5,
      delay: 0.8,
      ease: "easeInOut",
      repeat: Infinity
    }} data-id="element-100" data-mp="1vte5bzggmsty">
        <img src={heroKitImage} alt="Kit completo de Fórmula Emprendedora con libro y hojas de fórmulas" className="block w-full" data-id="element-101" data-mp="12mtr9c17d6rz" />
      </motion.div>
    </motion.div>;
}